import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import { isEmpty } from "lodash";
import SearchMyBooking from "app/pages/Account/SearchMyBooking/SearchMyBooking";
import { bindActionCreators } from "redux";
import { fetchSearchMyBooking } from "app/pages/Account/SearchMyBooking/searchMyBookingActionCreators";
import { useCallback, useContext } from "react";
import PropTypes from "prop-types";
import AppGlobalsContext from "app/AppGlobalsContext";
import { updateEmail } from "app/reducers/emailActionCreators";

const SearchMyBookingContainer = ({
	fetchSearchMyBooking = () => {},
	searchMyBooking = {},
	updateEmail = () => {},
}) => {
	const { brand } = useContext(AppGlobalsContext);
	const navigate = useNavigate();

	const handleFormSuccess = useCallback(
		(bookingReference, email) => {
			fetchSearchMyBooking({ bookingReference, email, brand }).then(res => {
				if (res.status === 200 && !isEmpty(res?.data?.booking)) {
					updateEmail(email);
					navigate(`/account/mybookings/${bookingReference}`, { replace: true });
				}
			});
		},
		[brand]
	);

	return <SearchMyBooking onFormSuccess={handleFormSuccess} searchMyBooking={searchMyBooking} />;
};

const mapStateToProps = state => {
	return {
		searchMyBooking: state.searchMyBooking,
	};
};

const mapDispatchToProps = dispatch =>
	bindActionCreators({ fetchSearchMyBooking, updateEmail }, dispatch);

SearchMyBookingContainer.propTypes = {
	fetchSearchMyBooking: PropTypes.func,
	searchMyBooking: PropTypes.object,
	updateEmail: PropTypes.func,
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(SearchMyBookingContainer);
